import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { TokenService, LogService, UtilsService, AbpSessionService } from 'abp-ng2-module';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import {
    AuthenticateModel,
    AuthenticateResultModel,
    SessionServiceProxy,
    TokenAuthServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { AppSessionService } from '@shared/session/app-session.service';

@Injectable()
export class AppAuthService {
    authenticateModel: AuthenticateModel;
    authenticateResult: AuthenticateResultModel;
    rememberMe: boolean;

    constructor(
        private _tokenAuthService: TokenAuthServiceProxy,
        private _router: Router,
        private _utilsService: UtilsService,
        private _tokenService: TokenService,
        private _logService: LogService,
        private _session: AppSessionService
    ) {
        this.clear();
    }

    logout(reload?: boolean): void {
        abp.auth.clearToken();
        abp.utils.deleteCookie(AppConsts.authorization.encryptedAuthTokenName);

        if (reload !== false) {
            location.href = AppConsts.appBaseUrl;
        }
    }

    authenticate(finallyCallback?: () => void): void {
        finallyCallback = finallyCallback || (() => {});

        this._tokenAuthService
            .authenticate(this.authenticateModel)
            .pipe(
                finalize(() => {
                    finallyCallback();
                })
            )
            .subscribe((result: AuthenticateResultModel) => {
                this.processAuthenticateResult(result);
            });
    }

    private processAuthenticateResult(authenticateResult: AuthenticateResultModel) {
        this.authenticateResult = authenticateResult;

        if (authenticateResult.accessToken) {
            // Successfully logged in
            this.login(
                authenticateResult.accessToken,
                authenticateResult.encryptedAccessToken,
                authenticateResult.expireInSeconds,
                this.rememberMe
            );
        } else {
            // Unexpected result!
            if (authenticateResult.shouldResetPassword) {
                // Pass userId and resetCode as query params if present
                const queryParams: any = {};
                if (authenticateResult.userId) {
                    queryParams.userId = authenticateResult.userId;
                }
                if (authenticateResult.passwordResetCode) {
                    queryParams.resetCode = authenticateResult.passwordResetCode;
                }
                this._router.navigate(['web/reset-password'], { queryParams });
            } else {
                this._logService.warn('Unexpected authenticateResult!');
                this._router.navigate(['web/login']);
            }
        }
    }

    private login(
        accessToken: string,
        encryptedAccessToken: string,
        expireInSeconds: number,
        rememberMe?: boolean
    ): void {
        const tokenExpireDate = rememberMe ? new Date(new Date().getTime() + 1000 * expireInSeconds) : undefined;

        this._tokenService.setToken(accessToken, tokenExpireDate);

        this._utilsService.setCookieValue(
            AppConsts.authorization.encryptedAuthTokenName,
            encryptedAccessToken,
            tokenExpireDate,
            abp.appPath
        );
        // ✅ VERY IMPORTANT
        // Initialize session AFTER login
        this._session.init().then(() => {
            const waitForUser = setInterval(() => {
                const role = this._session?.user?.role;
                if (role) {
                    clearInterval(waitForUser);
                    let initialUrl = UrlHelper.initialUrl;
                    if (initialUrl.indexOf('/login') > 0) {
                        initialUrl = AppConsts.appBaseUrl;
                    }
                    if (role.toLowerCase() === 'admin') {
                        // this._router.navigate(['/web/article-list']);
                        // this._router.navigate(['/app']);
                        location.href = initialUrl + 'app';
                    } else {
                        location.href = initialUrl + 'web/article-list';
                        // this._router.navigate(['/web/article-list']);
                    }
                }
            }, 100); // check every 100ms
        });

        // let initialUrl = UrlHelper.initialUrl;
        // if (initialUrl.indexOf('/login') > 0) {
        //     initialUrl = AppConsts.appBaseUrl;
        // }
        // alert(initialUrl);
        // location.href = initialUrl;
    }

    private clear(): void {
        this.authenticateModel = new AuthenticateModel();
        this.authenticateModel.rememberClient = false;
        this.authenticateResult = null;
        this.rememberMe = false;
    }
}
